export default "<div class=\"column\" ng-class=\"[$ctrl.cssClass]\" ng-transclude></div>"